import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DataList } from '@core/interfaces';

@Component({
  selector: 'z-display-only',
  templateUrl: './display-only.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class DisplayOnlyComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<boolean>();

  @Input() label: string;
  @Input() fieldName: string;
  @Input() emptyText: string = '';

  @Input() uppercase: boolean = true;

  @Input() listOfValues: DataList;
  @Input() listOfValuesColumn: 'value' | 'descr' = 'value';

  empty$ = new BehaviorSubject<boolean>(false);
  text$ = new BehaviorSubject<string>(null);

  constructor(private formGroup: FormGroupDirective) {}

  ngOnInit() {
    if (this.formGroup?.form?.get(this.fieldName)) {
      this.setText(this.formGroup.form.get(this.fieldName).value);
    }

    this.formGroup.form
      .get(this.fieldName)
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.setText(value);
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  setText(value: string) {
    if (value === '' || value === null || value === this.emptyText) {
      value = this.emptyText;
      this.empty$.next(true);
    } else {
      this.empty$.next(false);
    }

    if (this.listOfValues && this.listOfValues.data) {
      this.listOfValues.data.find((entry) => {
        if (value === entry.key) {
          this.text$.next(entry[this.listOfValuesColumn] as string);
        }
      });
    } else {
      this.text$.next(value);
    }
  }
}
